import React from 'react';
import "../components/styles/CustomerCenterPage.css";

const CustomerCenterPage = () => {
    const sendKakaotalk = () => {
        window.open('http://pf.kakao.com/_xkVeGn', '_blank');
    }

    const sendPhone = () => {
    }

    return (
        <div className="customer-center-page">
            <h2 className="title">언제어디서나 궁금한 내용을 물어보세요!</h2>
            <h1 className="main-title">고객센터</h1>

            <div className="inquiry-cards">
                <div className="inquiry-card kakao-card" role={"button"} onClick={() => sendKakaotalk()}>
                    <h3 className="inquiry-title">카카오톡 채널 상담</h3>
                    <p className="kakao-inquiry-time">월-금(공휴일제외) 10:00-22:00</p>
                    <button className="inquiry-button">문의하기 ➜</button>
                </div>

                <div
                    className="inquiry-card email-card"
                    role="button"
                    onClick={() => window.location.href = "tel:01055029714"} // 전화번호 변경
                >
                    <h3 className="inquiry-title">전화 상담</h3>
                    <p className="email-inquiry-time">월-금(공휴일제외) 10:00-22:00</p>
                    <p>T. 010 - 5502 - 9714</p>
                    <button className="inquiry-button">문의하기 ➜</button>
                </div>

            </div>
        </div>
    );
};

export default CustomerCenterPage;
